import * as React from "react";
import { cn } from "../../lib/utils";
import { Icon } from "../ui/Icon";
import { ClassValue } from "clsx";

export function Plan2PlanIconButtonWithTitle(props: {
  ariaPressed: boolean;
  title: string;
  onClick: () => void;
  icon: React.ReactNode;
  body?: React.ReactNode;
  className?: ClassValue[];
}) {
  return (
    <button
      type="button"
      aria-pressed={props.ariaPressed}
      title={props.title}
      onClick={props.onClick}
      className={cn(
        props.className,
        "flex flex-col items-center justify-start gap-1 rounded-card border px-1 py-2 transition",
        props.ariaPressed
          ? "bg-gold/15 text-gold border border-gold"
          : "border-line bg-surface-card text-ink-muted hover:bg-surface",
      )}
    >
      <Icon size={28} tone={props.ariaPressed ? "gold" : "default"}>
        {props.icon}
      </Icon>
      <span
        className={cn(
          "block w-full text-center text-2xs font-semibold leading-tight",
          props.ariaPressed ? "text-gold" : "text-ink",
        )}
      >
        {props.body ?? props.title}
      </span>
    </button>
  );
}
